export default __webpack_public_path__ + "static/media/SEC_1.584a0932.jpg";